import * as actionTypes from "../actions/actionTypes.js";

let initLanguage = {
  //language: "tr",
  code:"tr",
  name:"Türkçe",
  tr: {},
};

export default function languageReducer(state = initLanguage, action) {
 // console.log(state);
//debugger
  if (action === undefined) {
    return state;
  }
  switch (action.type) {
    case actionTypes.GET_TRANSLATIONS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
